/**
 * Compute the GraphQL variables for *refreshing* an already-paginated library
 * list (e.g. the 10s poll while a curation is still processing).
 *
 * The Apollo field policy's merge function (see mergeLists) treats `offset === 0`
 * as a full replace. A naive `refetch()` reuses the hook's original variables
 * (`offset: 0, limit: PAGE_SIZE`), which therefore truncates the list back to the
 * first page and makes scrolled-in items disappear from the tab. To refresh
 * without losing pagination, request the full loaded range as `limit`.
 */
export function computeLibraryRefreshVariables(
  { loadedCount, pageSize }: { loadedCount: number; pageSize: number },
): { limit: number; offset: number } {
  return { limit: Math.max(loadedCount, pageSize), offset: 0 };
}
